// extracted by mini-css-extract-plugin
export default {"background":"Footer_background__-7v7O","mask":"Footer_mask__Zkjnl","container":"Footer_container__iICw7","zuicy_logo_text":"Footer_zuicy_logo_text__Emqta"};